import React, { useEffect, useContext } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { CarouselContext, Slider, Slide } from 'pure-react-carousel';

import Image from '~/components/base/Image';

const StyledSlider = styled(Slider)`
    height: 100%;
    transform: translateY(-50px);
    border-radius: 53px;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        margin-left: -50px;
        transform: none;
        margin-top: 0;
        padding: 72px 0 30px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
        margin-left: -150px;
    }

    .carousel__slider-tray,
    .carousel__slider-tray-wrapper {
        height: 100%;
        border-radius: 53px;
    }
`;

const StyledSlide = styled(Slide)`
    border-radius: 53px;
`;

const SlideImage = styled(Image)`
    margin: 0 auto 0 20px;
    border-radius: 53px;
    height: 100%;
    z-index: 2;
    position: relative;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        margin: 0 auto;
    }
`;

const WashInstructionsImageSlider = ({
    images,
    mainSliderState,
    mainSliderDispatch
}) => {
    const carouselContext = useContext(CarouselContext);

    useEffect(() => {
        function onChange() {
            mainSliderDispatch({
                type: 'CHANGE_SLIDE',
                slideIndex: carouselContext.state.currentSlide
            });
        }

        carouselContext.subscribe(onChange);
        return () => carouselContext.unsubscribe(onChange);
    }, [carouselContext, mainSliderDispatch]);

    useEffect(() => {
        carouselContext.setStoreState({
            currentSlide: mainSliderState.currentSlide
        });
    }, [mainSliderState.currentSlide, carouselContext]);

    return (
        <StyledSlider>
            {images.map((image, index) => (
                <StyledSlide index={index} key={image.id}>
                    <SlideImage {...image} />
                </StyledSlide>
            ))}
        </StyledSlider>
    );
};

WashInstructionsImageSlider.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            altText: PropTypes.string.isRequired,
            sourceUrl: PropTypes.string.isRequired,
            localFile: PropTypes.shape({
                childImageSharp: PropTypes.shape({
                    gatsbyImageData: PropTypes.object.isRequired
                })
            })
        })
    ),
    mainSliderState: PropTypes.object,
    mainSliderDispatch: PropTypes.func
};

export default WashInstructionsImageSlider;
